import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { Table, Input, Button, Space, Modal } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import userService from "../../../../api/Authentication/AuthenticationService";
const { confirm } = Modal;
export default class PreviewAllUsers extends Component {
  constructor(props) {
    super(props);

    this.state = { allAvaliableUsers: [] };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    this.getAllUsers();
  }
  getAllUsers = () => {
    this.setState({ allAvaliableUsers: [] });
    userService
      .getAllUsers()
      .then((res) => {
        res.data.map((user, i) => {
          return this.setState({
            allAvaliableUsers: [
              ...this.state.allAvaliableUsers,
              {
                key: i + 1,
                en_fullname: user.en_fullname,
                userId: user.id,
                role: user.role,
                id_no: user.id_no,
                email: user.email,
              },
            ],
          });
        });
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentWillUnmount() { }

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() { }

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  deleteUser = (userId) => {
    let del = async () => {
      userService.deleteUser(userId)
        .then(result => {
          toast.success(`User Deleted Successfuly`, {
            position: toast.POSITION.TOP_CENTER,
          });
          this.getAllUsers();
        })
        .catch(err => {
          toast.error(`Unable to delete user`, {
            position: toast.POSITION.TOP_CENTER,
          });
        })
    };
    return confirm({
      title: "Delete user",
      content: "Delete user?",
      align: "right",
      onOk() {
        del();
      },
      onCancel() { },
    });
  };

  render() {
    let data =
      this.state.allAvaliableUsers != null
        ? this.state.allAvaliableUsers
          .sort((a, b) => a.createdAt > b.createdAt)
          .map((user, i) => {
            return {
              index: i + 1,
              name: user.en_fullname,
              id_no: user.id_no,
              email: user.email,
              role: user.role,
              action: (
                <Button
                  className="btn btn-danger text-white"
                  onClick={() => this.deleteUser(user.userId)}
                >
                  delete
                </Button>
              ),
            };
          })
        : null;

    const columns = [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        ...this.getColumnSearchProps("name"),
      },
      {
        title: "ID No",
        dataIndex: "id_no",
        key: "id_no",
        ...this.getColumnSearchProps("id_no"),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        ...this.getColumnSearchProps("email"),
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        ...this.getColumnSearchProps("role"),
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
      },
    ];
    return (
      <>
        <h5 className="m-0">Users</h5>
        <Row form>
          <Col md="12" className="form-group  mt-4">
            <Table
              columns={columns}
              dataSource={data !== null ? data : null}
              className="p-0 m-0"
              pagination={{ pageSize: 5, position: ["bottomCenter"] }}
              style={{ textAlign: "center" }}
            />
          </Col>
        </Row>
      </>
    );
  }
}
